<template>
	<VideoPreviewPoster v-track="'video-play-button'" :thumbnail="props.thumbnail">
		<div class="recording-footer position-absolute bottom-0 right-0 w-100 d-flex flex-column align-end">
			<a
				v-if="showSessionNumber"
				:href="sessionRoute"
				class="session-number px-1 text-truncate"
				:aria-label="`Open session ${props.sessionNumber}`"
				@click="navigateToSession($event)">
				Session #{{ props.sessionNumber }}
			</a>
		</div>
	</VideoPreviewPoster>
</template>
<script lang="ts" setup>
	import { computed, getCurrentInstance } from "vue";
	import PartialRecordingIndicator from "./PartialRecordingIndicator.vue";
	import VideoPreviewPoster from "@common-ui/media/VideoPreviewPoster.vue";
	import { shouldLetBrowserHandleClick } from "@/helpers/linkNavigation";
	import { IndexableEntityType } from "@/types/search/IndexableEntityTypes";

	const props = defineProps<{
		sessionNumber?: number;
		incompleteUpload?: boolean;
		thumbnail?: string;
		sessionId?: string | null;
		parentType: IndexableEntityType;
		mediaOrganizationId?: string;
		me?: any;
	}>();

	const emit = defineEmits<{ "open-incomplete-recording": [] }>();

	const instance = getCurrentInstance();

	const showSessionNumber = computed(() => {
		return props.me && props.parentType !== "conversation" && props.sessionNumber;
	});
	const sessionRoute = computed(() => (props.sessionId ? `/conversations/${props.sessionId}` : undefined));

	async function navigateToSession(event: MouseEvent) {
		event.stopPropagation();
		if (!props.sessionId || !props.me) {
			event.preventDefault();
			return;
		}

		if (props.mediaOrganizationId && props.mediaOrganizationId !== props.me.organization?.id) {
			event.preventDefault();
			await (instance?.proxy as any).$root.$confirm.open(
				"Heads up!",
				"This stuff is in another account. Contact the project owner to get access to the account.",
				false,
				"OK",
				"",
				false,
				true
			);
			return;
		}
		if (shouldLetBrowserHandleClick(event)) return;

		event.preventDefault();
		(instance?.proxy as any)?.$router.push(`/conversations/${props.sessionId}`);
	}
</script>
<style lang="scss" scoped>
	.recording-footer {
		z-index: 2;
		pointer-events: none;
		> * {
			pointer-events: auto;
		}
	}
	.session-number {
		background-color: #00000088;
		width: 100%;
		color: #fff;
		font-size: 12px;
		font-weight: 600;
		z-index: 2;
		text-decoration: none;
	}
</style>
